import { NgModule } from '@angular/core';
import { CacheResourcePipe } from './cacheResource.pipe';
import { CleanTextPipe } from './cleanText.pipe';
import { Converttohttps } from './converttohttps.pipe';
import { CleverFragmentPipe } from './fragment.pipe';
import { LinkifyPipe } from './linkify.pipe';
import { LinkifyEdomPipe } from './linkifyedom.pipe';
import { SafePipe } from './safe.pipe';
import { SafeHtmlPipe } from './safehtml.pipe';
import { SafeStylePipe } from './safestyle.pipe';
@NgModule({
  declarations: [
    SafePipe,
    SafeHtmlPipe,
    LinkifyPipe,
    CleanTextPipe,
    LinkifyEdomPipe,
    CleverFragmentPipe,
    CacheResourcePipe,
    SafeStylePipe,
    Converttohttps,
  ],
  exports: [
    SafePipe,
    SafeHtmlPipe,
    LinkifyPipe,
    CleanTextPipe,
    LinkifyEdomPipe,
    CleverFragmentPipe,
    CacheResourcePipe,
    SafeStylePipe,
    Converttohttps,
  ],

  providers: [],
})
export class PipeModule {}
